import { createMedicalRequest } from './createMedicalRequest'
import { listAllDiagnosticHypotheses } from './listAllDiagnosticHypotheses'

export default {
  createMedicalRequest,
  listAllDiagnosticHypotheses
}
